export const ROUTING_URLS = {
    landing: 'landing',
    verfication: 'verification',
    dashboard: 'dashboard',
};
